import { images } from '../constants';

const games = [
    {
        id: 1,
        image: images.gameBannerSUMO,
        logo: images.gameSumoRobot,
        title: '相撲機器人',
        content: '相撲機器人比賽是一對一的激烈對戰，機器人嘗試將對方推出場地，參賽者依年齡與機器人規格分組。',
        paragraphs: [
            '相撲機器人比賽是 WRG 中最受歡迎的一對一挑戰之一。就像日本傳統相撲一樣，兩台機器人嘗試將對手推出場地來獲得分數。',
            '參賽者會依年齡與機器人規格分組，以確保比賽公平且有趣。'
        ],
        gallery: [
            images.gameGallerySUMO01,
            images.gameGallerySUMO02
        ],
        category: {
            intro: '共有 3 個子組別：',
            list: [
                {
                    id: 1,
                    title: "自動相撲機器人組別",
                    divisions:[
                        { 
                            id: 0,
                            title: "少年組",
                            features: [
                                "參賽年齡：8 至 14 歲",
                                "機器人尺寸：20cm x 20cm 以內",
                                "機器人重量：1.5 公斤以下"
                            ]
                        },
                        { 
                            id: 1,
                            title: "BASIC 少年組",
                            features: [
                                "參賽年齡：8 至 14 歲",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：1.5 公斤以下"
                            ]
                        },{ 
                            id: 2,
                            title: "青年組",
                            features: [
                                "參賽年齡：15 至 19 歲",
                                "機器人尺寸：20cm x 20cm 以內",
                                "機器人重量：3 公斤以下"
                            ]
                        },{ 
                            id: 3,
                            title: "STEM 組",
                            features: [
                                "參賽年齡：8 至 19 歲",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：2.5 公斤以下"
                            ]
                        },
                    ]
                },{
                    id: 2,
                    title: "遙控相撲機器人組別",
                    divisions:[
                        { 
                            id: 0,
                            title: "少年組",
                            features: [
                                "參賽年齡：8 至 14 歲",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：1.5 公斤以下"
                            ]
                        },
                        { 
                            id: 1,
                            title: "BASIC 少年組 ",
                            features: [
                                "參賽年齡：8 至 14 歲",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：1.5 公斤以下"
                            ]
                        },{ 
                            id: 2,
                            title: "少年組 ADVANCE",
                            features: [
                                "參賽年齡：8 至 14 歲",
                                "需要使用V7RC APP進行操控",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：1.5 公斤以下",
                                "最多 4 顆驅動馬達。不允許使用無刷馬達。"
                            ]
                        },{ 
                            id: 3,
                            title: "青年組",
                            features: [
                                "參賽年齡：15 至 19 歲",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：3 公斤以下"
                            ]
                        },{ 
                            id: 4,
                            title: "青年組 ADVANCE",
                            features: [
                                "參賽年齡：15 至 19 歲",
                                "需要使用V7RC APP進行操控",
                                "機器人尺寸：25cm x 25cm 以內",
                                "機器人重量：3 公斤以下",
                                "允許使用任何種類的馬達與電池"
                            ]
                        },
                    ]
                },{
                    id: 3,
                    title: "家庭相撲組",
                    divisions:[ ]
                }
            ]
        },
        requirements: {
            intro: '每個比賽組別都包含詳細的機器人尺寸與規格規範。規則中亦清楚列出參賽者違規與禁止行為。請在報名前仔細閱讀比賽規則。'
        },
        arena: {
            intro: '（待公告）',
            list: []
        },
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025 WRG 自動相撲機器人',
                    url: '/files/gamerules/WRG2025-TW-Autonomous-SUMO.pdf'
                },
                {
                    id: 2,
                    title: '2025 WRG 遙控相撲機器人',
                    url: '/files/gamerules/WRG2025-TW-Remote-Control-SUMO.pdf'
                },
                {
                    id: 3,
                    title: '2025 WRG 家庭相撲',
                    url: '/files/gamerules/WRG2025-TW-Autonomous-SUMO-Family.pdf'
                }
            ]
        }
    },
    {
        id: 2,
        image: images.gameBannerLine,
        logo: images.gameLineTracing,
        title: '循線機器人',
        content: '存取完整的比賽時程與活動資訊。',
        paragraphs: [
            '這是一個個人機器人比賽，利用最簡單的電子與機械原理即可循線，不需要撰寫程式。',
            '機構設計與電子電路的穩定性將決定你的機器人是否能比他人更快，成為極具挑戰性的個人專案。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025 Beam 循線比賽',
                    url: '/files/gamerules/WRG2025-TW-BEAM-Line_Tracing.pdf'
                },
                {
                    id: 2,
                    title: '2025 Beam 對戰比賽',
                    url: '/files/gamerules/WRG2025-TW-BEAMBattle_Line_Tracing.pdf'
                }
            ]
        }
    },
    {
        id: 3,
        image: images.gameBannerProg,
        logo: images.gameProgrammable,
        title: '可編程循線機器人',
        content: '與其他參賽者交流與切磋。',
        paragraphs: [
            '透過整合感測器與 MCU 處理能力，參賽者的目標是打造最快的循線機器人，爭取最佳成績。',
            '每位選手必須透過賽前練習蒐集賽道數據，真正考驗程式設計與應變能力。千萬不要錯過這場刺激的比賽！'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025 可編程循線',
                    url: '/files/gamerules/WRG2025-TW-Programming-Line_Tracing.pdf'
                }
            ]
        }
    },
    {
        id: 4,
        image: images.gameBannerBallFight,
        logo: images.gameBallFighting,
        title: '鬥球機器人',
        content: '',
        paragraphs: [
            '規則簡單：時間結束時，哪一方場地的球較少即為勝利。參賽隊伍必須設法將球推入對手場地，同時阻止球進入自己的場地。',
            '最多 4 人組隊參賽。勝利的關鍵在於機器人的靈活性以及團隊合作。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025 鬥球比賽 – OPEN',
                    url: '/files/gamerules/WRG2025-TW-BallFightingRCRobot.pdf'
                }
            ]
        }
    },
    {
        id: 5,
        image: images.gameBannerSoccer,
        logo: images.soccerW3,
        title: '足球三國對抗賽',
        content: '創新且刺激的賽事',
        paragraphs: [
            '足球三國對抗賽（W3-Soccer Robots）是一項模擬足球的機器人競賽。參賽隊伍需操作或自主控制機器人，將比賽用球射入對方球門，並以失球數（LG, Lost Goals）最少作為勝負判定。比賽時間為 3 分鐘，賽制包含聯賽、淘汰賽與決賽。',
        ],
        category: {
            intro: '參賽者資格：',
            list: [
                {
                    id: 1,
                    title: "競賽組別",
                    divisions:[
                        { 
                            id: 1,
                            title: "OPEN組別",
                            features: [
                                "每隊由 3 名成員組成。年齡組別為公開組（8 至 99 歲）。",
                                "每隊可以有或沒有指導老師/教練，但僅能有 1 位。1 位老師或教練可同時指導多隊。",
                                "每位參賽者僅能加入 1 支隊伍。",
                                "機器人尺寸：不得大於 20 x 20 公分，高度不限。比賽日將提供 20 x 20 公分測量盒以確認尺寸。",
                                "機器人重量：1.0 公斤以下"
                            ]
                        }
                    ]
                }
            ]
        },
        requirements: {
            intro: '每個比賽組別都包含詳細的機器人尺寸與規格規範。規則中亦清楚列出參賽者違規與禁止行為。請在報名前仔細閱讀比賽規則。'
        },
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025足球三國對抗賽競賽規則 – OPEN',
                    url: '/files/gamerules/WRG2025-TW-W3-Soccer.pdf'
                }
            ]
        }
    },
    {
        id: 5,
        image: images.gameBannerSoccer,
        logo: images.gamesSoccer,
        title: '足球機器人 4 x 4',
        content: '',
        paragraphs: [
            '沒有什麼比 4 對 4 的足球機器人比賽更刺激！這場比賽不僅考驗每位選手的靈活操控能力，還挑戰每台機器人的耐久性與機動性。',
            '每支隊伍必須事先精心設計機器人，規劃攻擊與防守角色，以取得優勢並盡可能多得分。別錯過這場激動人心的比賽——立即報名！'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                {
                    id: 1,
                    title: '2025 足球機器人 4 x 4 – OPEN',
                    url: '/files/gamerules/WRG2025-TW-Soccer4x4.pdf'
                }
            ]
        }
    },
    {
        id: 6,
        image: images.gameBannerOMG,
        logo: images.gameOMG,
        title: '一分鐘挑戰賽',
        content: '存取展示與資源，提升你的學習體驗。',
        paragraphs: [
            '一分鐘機器人比賽節奏快速、競爭激烈，不容小覷。每年參賽者都能以創意與傑出表現驚豔評審。',
            '這是一項以程式設計為核心的自動機器人比賽，為個人參賽項目。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                { id: 1, title: '2025 OMG：運球 – 少年組', url: '/files/gamerules/WRG2025-TW-OMG-CarryTheBallSTEAM.pdf' },
                { id: 2, title: '2025 OMG：投箱 – 青少年組', url: '/files/gamerules/WRG2025-TW-OMG-DropTheBox.pdf' },
                { id: 3, title: '2025 OMG：擊球 – 青少年組', url: '/files/gamerules/WRG2025-TW-OMG-HitTheBallSenior.pdf' },
                { id: 4, title: '2025 OMG：移罐 – 少年組', url: '/files/gamerules/WRG2025-TW-OMG-MoveTheCanJunior.pdf' },
                { id: 5, title: '2025 OMG：射門 – 少年組', url: '/files/gamerules/WRG2025-TW-OMG-ShootTheBallJunior.pdf' }
            ]
        }
    },
    {
        id: 7,
        image: images.gameBannerSecure,
        logo: images.gameSecureRobot,
        title: '智慧救援機器人',
        content: '存取展示與資源，提升你的學習體驗。',
        paragraphs: [
            '這項比賽結合循線與解迷功能，並需在限時內完成任務，是 WRG 中最具挑戰性的項目之一。',
            '參賽者必須設計出能在複雜環境中導航並高效執行任務的智慧型機器人。',
            '此為 OPEN 組別，歡迎各年齡層的選手挑戰。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                { id: 1, title: '2025 智慧救援機器人 – OPEN', url: '/files/gamerules/WRG2025-TW-IntelligentSecureRobot.pdf' }
            ]
        }
    },
    {
        id: 8,
        image: images.gameBannerInno,
        logo: images.gameInnovativeRobots,
        title: '創新機器人',
        content: '子組別：創新競賽與不可思議的機器',
        paragraphs: [
            'WRG 的年度重點項目之一就是創新機器人組別。該比賽分為兩個子組別：STEAM 10-19 與超級機關。每年 STEAM 10-19 類別都有獨特主題，今年的主題是「AI 機器人」，參賽者必須設計能具備 AI 運算能力的機器人。',
            '超級機關組則一如既往強調複雜性與創造力。參賽者必須整合超過四塊控制板，並搭配感測器與馬達，建造能持續循環運作的「驚奇」機械。最重要的是，此為 OPEN 組別，歡迎所有年齡的參賽者加入挑戰。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                { id: 1, title: '2025 創新 AI 機器人 – 少年/青年組', url: '/files/gamerules/WRG2025-TW-Innovative Robot.pdf' },
                { id: 2, title: '2025 不可思議的機器 – OPEN', url: '/files/gamerules/WRG2025-TW-IncredibleRobotics.pdf' }
            ]
        }
    },
    {
        id: 9,
        image: images.gameBannerDroneSoccer,
        logo: images.DroneSocccer,
        title: '無人機足球',
        content: '操控無人機足球，決勝賽場！',
        paragraphs: [
            '本規則依據 FAI F9A-B 國際標準 制定，適用於 OPEN 組（8–99歲） 的無人機足球賽事。',
            '比賽採 三人一隊 制，於 長6公尺、寬3公尺、高3公尺 的標準場地進行。',
            '每場比賽時間為 3分鐘，採 累計進球制，攻擊手進球得1分，完成回場後再次進球可再得1分，除總決賽外，罰球直接扣1分。',
            '比賽採用 雙模電子計分球門 與 LED辨識燈系統，以確保公平與可視化。',
            '賽制為 淘汰制，勝隊晉級，最終冠軍依得分與勝場決定',
            '所有違規行為（如提前起飛、干擾比賽或不當行為）將依規處以警告、黃牌或紅牌。',
            '最終裁定權由 主辦單位與裁判組 保留。'
        ],
        downloads: {
            intro: '比賽規則文件',
            list: [
                { id: 1, title: '2025 機器人足球賽事規則', url: '/files/gamerules/WRG2025-機器人競賽規則-Drone-Soccer.pdf' },
            ]
        }
    }
];

export default games;
